export default {"src":"/_next/static/media/user-tie.6e401105.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};